import React from "react";
import {FiSave} from "react-icons/fi";
import Field from "../Field.tsx";
import Tooltip from "../Tooltip.tsx";
import CreateProjectStepSection from "./CreateProjectStepSection.tsx";
import {SAVE_PRESET_DISABLED_TOOLTIP} from "./saveTemplateConstants.ts";

interface SaveTemplateFieldProps {
  canSave: boolean;
  value: string;
  onChange: (name: string) => void;
  compact?: boolean;
}

export const SaveTemplateField: React.FC<SaveTemplateFieldProps> = (
  {canSave, value, onChange, compact = false}: SaveTemplateFieldProps
) => {
  const field = (
    <Tooltip text={SAVE_PRESET_DISABLED_TOOLTIP} condition={!canSave} position="top">
      <Field
        label="Template name (optional)"
        placeholder="Enter a name to reuse this setup"
        classInput={`${compact ? "h-11" : ""} disabled:cursor-not-allowed disabled:opacity-50`}
        icon={FiSave}
        value={value}
        disabled={!canSave}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
          onChange(event.target.value)}
      />
    </Tooltip>
  );

  if (compact) {
    return <div data-testid="save-template-section">{field}</div>;
  }

  return (
    <CreateProjectStepSection
      testId="save-template-section"
      title="Save as template"
      description="Reuse this exact source, targets and options the next time you upload."
    >
      {field}
    </CreateProjectStepSection>
  );
};
